import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable()
export class DashboardBackofficeEntryService {
  handleInitialEntry(route: ActivatedRoute, router: Router): boolean {
    if (router.url.includes('/home-backoffice')) {
      const hasBackofficeParam =
        route.snapshot.queryParams['backoffice'] === 'true';
      const hasBackofficeSession =
        sessionStorage.getItem('login_destination') === 'backoffice';

      if (!hasBackofficeParam && !hasBackofficeSession) {
        sessionStorage.removeItem('login_destination');
        router.navigate(['/dashboard/home']);
        return true;
      }
    }

    const hasBackofficeParam =
      route.snapshot.queryParams['backoffice'] === 'true';
    const isAlreadyInBackoffice = router.url.includes('/home-backoffice');
    const isProfileBackoffice =
      router.url.includes('/profile') && router.url.includes('mode=backoffice');

    if (!hasBackofficeParam && !isAlreadyInBackoffice && !isProfileBackoffice) {
      sessionStorage.removeItem('login_destination');

      if (router.url === '/dashboard/home' || router.url === '/dashboard') {
        sessionStorage.removeItem('login_destination');
      }
    }

    if (hasBackofficeParam && !isAlreadyInBackoffice) {
      sessionStorage.setItem('login_destination', 'backoffice');
      router.navigate(['/dashboard/home-backoffice']);
      return true;
    }

    if (
      isAlreadyInBackoffice &&
      sessionStorage.getItem('login_destination') === 'backoffice'
    ) {
      sessionStorage.removeItem('login_destination');
    }

    return false;
  }
}
